import { Stack, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { useResponsive } from 'src/hooks/use-responsive';
import {
  AiInterviewState,
  PreScreeningState,
  ProfileState,
  ScreeningState,
} from './constants/constants-nav';
import AiInterviewGroup from './ai-interview-group';
import PreScreeningGroup from './pre-screening-group';
import ProfileGroup from './profile-group';
import ScreeningGroup from './screening-group';
import { useCandidateProfileContext } from './hooks/use-candidate-profile-context';

const RightContainer = ({ jobId, navGroup, setNavGroup }) => {
  // hooks
  const mdUp = useResponsive('up', 'md');
  const { navigationItems } = useCandidateProfileContext();

  return (
    <Stack
      sx={{
        overflow: 'auto',
        height: '100%',
      }}
    >
      <Stack
        direction="row"
        width="100%"
        spacing={{
          xs: '12px',
          md: '0px',
        }}
        sx={{
          overflowX: 'auto',
          scrollbarColor: 'transparent transparent',
        }}
        justifyContent="center"
      >
        {navigationItems.map((item, index) => (
          <Stack
            spacing={{
              xs: '12px',
              md: '0px',
            }}
            sx={{
              backgroundColor:
                navGroup === item
                  ? 'background.primaryAccent1'
                  : 'background.primaryGrey2',
              color:
                navGroup === item
                  ? 'content.primaryWhite'
                  : 'content.primaryBlack1',
              borderRadius: {
                md: (() => {
                  if (index === 0) {
                    if (index === 0 && index === navigationItems.length - 1)
                      return '8px';
                    return '8px 0px 0px 8px';
                  }
                  if (index === navigationItems.length - 1)
                    return '0px 8px 8px 0px';
                  return '0px 0px 0px 0px';
                })(),
                xs: '24px',
              },
              width: { xs: '120px', md: `${100 / navigationItems.length}%` },
              maxWidth: '250px',
              height: { xs: '24px', md: '44px' },
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              py: { xs: '4px', md: '12.5px' },
              px: { xs: '8px', md: '16px' },
            }}
            key={index}
            onClick={() => setNavGroup(item)}
          >
            <Typography
              variant={mdUp ? 'input' : 'caption'}
              sx={{ fontWeight: 500, lineHeight: 'normal' }}
              noWrap
            >
              {item}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Stack
        sx={{
          py: '28px',
          px: {
            xs: '4px',
            md: '18px',
          },
          height: '100%',
        }}
      >
        {navGroup === ProfileState && <ProfileGroup jobId={jobId} />}
        {navGroup === PreScreeningState && <PreScreeningGroup jobId={jobId} />}
        {navGroup === ScreeningState && <ScreeningGroup />}
        {navGroup === AiInterviewState && <AiInterviewGroup jobId={jobId} />}
      </Stack>
    </Stack>
  );
};

export default RightContainer;

RightContainer.propTypes = {
  jobId: PropTypes.string,
  navGroup: PropTypes.string.isRequired,
  setNavGroup: PropTypes.func.isRequired,
};
